import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const ConfirmModal = ({
  title,
  message,
  isShown,
  isPerformingAction,
  onConfirm,
  onCancel,
  error
}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    title={ title }
    btnConfirmTitle="Ok"
    btnConfirmClass={ `btn-danger ${ isPerformingAction ? 'loading' : '' }` }
    btnCancelTitle="Cancel"
    onConfirm={ onConfirm }
    onCancel={ onCancel }
  >
    <span>
      { message }
    </span>
    {
      error
      && <div className="toast toast-error">
        { error }
      </div>
    }
  </ModalWrapper>
);

ConfirmModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  isShown: PropTypes.bool,
  isPerformingAction: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  error: PropTypes.string
};

ConfirmModal.defaultProps = {
  title: null,
  message: null,
  isShown: false,
  isPerformingAction: false,
  error: null
};

export default ConfirmModal;
